module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b002e7fb3cade0f9568f35feca06a9cb.png";